/**
 * Go-to-definition — resolves the qualified name at the cursor to the
 * source location of its defining symbol.
 */

import type { Location } from "vscode-languageserver";
import type { CursorContext } from "../workspace/cursor-context.js";
import type { SymbolTable } from "../workspace/symbol-table.js";
import type { Workspace } from "../workspace/workspace.js";
import { resolveSymbolAtCursor } from "../workspace/resolve.js";
import { toLspRange } from "../lsp-types.js";

export function provideDefinition(
  workspace: Workspace,
  symbols: SymbolTable,
  cursor: CursorContext,
  uri: string,
  line: number,
  character: number
): Location | null {
  const sym = resolveSymbolAtCursor(workspace, symbols, cursor, uri, line, character);
  const span = sym?.nameSpan ?? sym?.declSpan;
  if (!sym || !sym.definingUri || !span) return null;

  return {
    uri: sym.definingUri,
    range: toLspRange(span),
  };
}
